/** 排班模式设置 */
<template>
  <div id="schedulingTypeForm">

    <div class="schedulingTypeForm-title">
      <img class="icon-line" src="../../../assets/img/line.png" alt="" />
      <div>{{ lineName }}</div>
    </div>

    <div class="schedulingTypeForm-body">
      <div class="schedulingTypeForm-body-head">请选择要创建的排班模式：</div>
      <div class="schedulingTypeForm-body-item" v-for="item in $const.SCHELINGTYPE" :key="item.value" @click="postSchedulingType(item.value)">
        <div>{{ item.label }}</div>
        <div>{{ item.des }}</div>
        <img src="../../../assets/img/right.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "schedulingTypeForm",
  data() {
    return {
      lineId: this.$route.query.lineId,
      lineName: this.$route.query.lineName
    };
  },
  watch: {
    dialogVisible3(val) {
      if (!val) {
        this.$refs.priceForm.resetFields();
      }
    },
  },
  methods: {
    // 修改排班模式
    async postSchedulingType(schedulingType) {
      let url = "/api/v1/manage/line/schedulingType";
      let params = {
        lineId: this.lineId,
        schedulingType,
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$router.replace({
          path: "/schedulingSettingEdit",
          query: { lineId: this.lineId }
        });
      }
    },
  }
};
</script>

<style lang="less" scoped>
#schedulingTypeForm {
  padding: 0 20px;

  .schedulingTypeForm-title {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    div {
      margin-left: 20px;
      font-size: 30px;
      font-weight: bold;
    }
  }

  .schedulingTypeForm-body {
    &-head {
      margin-bottom: 50px;
      font-size: 17px;
      font-weight: bold;
    }
    &-item {
      width: 300px;
      height: 300px;
      padding: 40px;
      margin-right: 50px;
      box-sizing: border-box;
      border-radius: 25px;
      color: white;
      cursor: pointer;
      display: inline-block;

      &:nth-child(2) {
        background: #409efc url("../../../assets/img/scheduing_bg1.png")
          no-repeat;
      }
      &:nth-child(3) {
        background: #35363b url("../../../assets/img/xuanzuo.png")
          no-repeat;
      }
      &:nth-child(4) {
      background: #1cbc6c url("../../../assets/img/scheduing_bg2.png")
          no-repeat;
      }

      div {
        &:nth-child(1) {
          margin-bottom: 20px;
          font-size: 25px;
          font-weight: bold;
        }
        &:nth-child(2) {
          margin-bottom: 25px;
          font-size: 18px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
